import React from 'react'
import { DocumentImageBroken } from '@fs/zion-icon'
import { css } from '@emotion/core'

const brokenIconBackgroundCss = css`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(84, 86, 90, 0.7); // gray70
  z-index: 1;
  pointer-events: none;
`
const memoryBrokenCss = css`
  position: absolute;
  top: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  color: black;
`

export function MissingMemoryIcon({ label }) {
  return (
    <div
      css={[brokenIconBackgroundCss, memoryBrokenCss]}
      className="image-broken-icon"
      data-testid="missing-memory-icon"
    >
      <DocumentImageBroken size="md" color="white" aria-label={label} />
    </div>
  )
}
